<app-navigation></app-navigation>
<router-outlet></router-outlet>
<div class="fixed bottom-0 left-0 px-1">
    <button color="primary" mat-icon-button (click)="toggleShowAppVersion()">
        <mat-icon>info</mat-icon>
    </button>
    <span @fadeInOut *ngIf="showAppVersion">App Version: {{ appVersion }}</span>
</div>
